import * as Sentry from "@sentry/react";
import { shouldCapture } from "./shouldCapture.js";
import { CaptureMessage } from "./types.js";

export const captureMessage: CaptureMessage = (message, captureContext) => {
    const { description, errorFingerprint, notifyOnNewIssue = false, projectName, sampleRate, ...sentryCaptureContext } = captureContext;

    if (shouldCapture({ sampleRate }) === false) return;

    Sentry.addBreadcrumb({
        type: "info",
        category: "description",
        message: description,
    });

    const tagsAggregated = {
        ...("tags" in sentryCaptureContext ? sentryCaptureContext.tags : {}),
        ...(notifyOnNewIssue ? { notification_trigger: "new_issue" } : {}),
        ...(projectName ? { project: projectName } : {}),
    };

    Sentry.captureMessage(message, {
        ...(errorFingerprint ? { fingerprint: ["{{ default }}", errorFingerprint] } : {}),
        ...sentryCaptureContext,
        ...(Object.keys(tagsAggregated).length > 0 ? { tags: tagsAggregated } : {}),
    });
};
